import React from 'react';
import {
  ArrowRightGray,
  AttentionIcon,
  CompletedStep,
  CurrentStep,
  UnselectedStep,
} from 'shared/components/ui/ProjectIcons';

type RouteProgressStepProps = {
  stepLabel: string;
  status: 'completed' | 'in-progress' | 'upcoming' | 'attention';
  finalStep: boolean;
};

const RouteProgressStep = ({
  stepLabel,
  status,
  finalStep,
}: RouteProgressStepProps) => {
  const getStepIcon = () => {
    switch (status) {
      case 'attention':
        return <AttentionIcon />;
      case 'completed':
        return <CompletedStep />;
      case 'in-progress':
        return <CurrentStep />;
      case 'upcoming':
      default:
        return <UnselectedStep />;
    }
  };

  const getLabelClassName = () => {
    return status === 'in-progress' ? 'text-ui-cta-primary font-bold' : '';
  };

  return (
    <div className="flex items-center transition-colors duration-300">
      {/* The tint wraps the step itself; the separator arrow stays outside
                it, so the pills read as discrete steps with gaps between them. */}
      <span className="flex items-center rounded-lg bg-teal-t10 px-3 py-2">
        <span className="mb-1 mr-1.5">{getStepIcon()}</span>
        <label
          className={`${getLabelClassName()} text-ui-text-secondary-text transition-colors duration-300`}
        >
          {stepLabel}
        </label>
      </span>
      {!finalStep && (
        <span className="mx-3">
          <ArrowRightGray />
        </span>
      )}
    </div>
  );
};

export default RouteProgressStep;
